import { SeatSelectTypes } from "~components/reservation/constants";
import { log } from "~features/seated-reservation/helpers/stateLogger";
import { dontUnselectSeatsPrompt } from "~features/seated-reservation/helpers/userPrompt";
import {
  getAvailableCategoriesForChart,
  getSelectableZones,
} from "~features/seated-reservation/helpers/zoneFilters";
import { getState, setState, StoreState } from "../index";
import { selectBestSeats } from "./selectBestSeats";
import { ConvergeSdk } from "@seeka-labs/converge";

interface ActionProps {
  options: Partial<StoreState["options"]>;
}

export const updateOptions = async (
  payload: ActionProps,
  converge?: ConvergeSdk
) => {
  log("updateOptions", payload);

  const state = getState();

  if (dontUnselectSeatsPrompt(state.seats)) {
    return;
  }

  const newOptions = payload.options;

  const changedCoverType =
    newOptions.coverType && state.options.coverType !== newOptions.coverType;

  const changedZoneType =
    newOptions.zoneType && state.options.zoneType !== newOptions.zoneType;

  const hasChanged = changedCoverType || changedZoneType;

  const changedState: Partial<StoreState> = {
    seats: hasChanged ? null : state.seats,
    // selectBestOnChange: hasChanged ? true : false,
    selectionType: hasChanged ? "none" : state.selectionType,
    options: {
      ...state.options,
      ...newOptions,
    },
  };

  if (hasChanged) {
    const selectableZones = getSelectableZones(
      state.releasedZones,
      state.zones,
      changedState.options,
      state.isAdmin
    );

    const availableCategories = getAvailableCategoriesForChart(selectableZones);

    void state.chart?.changeConfig({
      availableCategories: availableCategories?.length
        ? availableCategories
        : [""],
    });

    changedState.selectableZones = selectableZones;
    changedState.sidebarIndex = 1;
    changedState.currentSection = undefined;
    changedState.currentZone = undefined;
    changedState.seats = [];
    changedState.options.filterActive =
      newOptions.filterActive === false ? false : true;

    void state.chart.clearSelection();
    void state.chart.resetView();
  }

  const isFreeSelect =
    (newOptions.seatSelectType || state.options.seatSelectType) ===
    SeatSelectTypes.FREE_SELECT;
  const amount = newOptions.amount || state.options.amount;

  const hasSelectTypeChanged =
    newOptions.seatSelectType &&
    newOptions.seatSelectType !== state.options.seatSelectType;

  const hasAmountChanged =
    newOptions.amount && newOptions.amount !== state.options.amount;

  void state.chart?.changeConfig({
    numberOfPlacesToSelect: isFreeSelect ? null : amount,
    maxSelectedObjects: isFreeSelect ? amount : null,
  });

  setState({
    ...changedState,

    // reset all seats for now when changing options
    seats: [],
    // sidebarIndex: hasSelectTypeChanged && state.sidebarIndex === 3 ? 2 : 1
  });

  // Only activate select best seats if we alread have seats selected.
  // If we are outside of selected seats we only want the amount to be
  // implicitly updated and not trigger an auto select
  if (hasAmountChanged && state.seats?.length) {
    await selectBestSeats(undefined, converge);
  }
};
